import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useSWR from "swr";

import API from "../../../services/apiHelpers";

export function useArticles({ category, limit }) {
  const { i18n } = useTranslation();
  const articlesTags = useSelector(
    state => state.articles.articlesTags.results
  );

  const { data } = useSWR([category, limit], () =>
    API().get("/api/v2/articles/", {
      params: {
        lang_code: Cookies.get("user_lang")
          ? Cookies.get("user_lang").toUpperCase()
          : i18n.language.toUpperCase(),
        ordering: "-published_at",
        publish_status: 3,
        limit: limit || 3,
        category,
      },
    })
  );

  return {
    articles: data ? data.data.results : [],
    articlesTags,
  };
}

export function useRecentArticles() {
  const { i18n } = useTranslation();
  const articlesTags = useSelector(
    state => state.articles.articlesTags.results
  );
  const url = "/api/v2/articles/";

  const { data } = useSWR(url, () =>
    API().get(url, {
      params: {
        lang_code: Cookies.get("user_lang")
          ? Cookies.get("user_lang").toUpperCase()
          : i18n.language.toUpperCase(),
        ordering: "-published_at",
        publish_status: 3,
        limit: 6,
      },
    })
  );

  return {
    articles: data ? data.data.results : [],
    articlesTags,
  };
}

export function useFeaturedArticles() {
  const { i18n } = useTranslation();

  const url = "/api/v2/featured-articles/";

  const { data } = useSWR(url, () =>
    API().get(url, {
      params: {
        lang_code: Cookies.get("user_lang")
          ? Cookies.get("user_lang").toUpperCase()
          : i18n.language.toUpperCase(),
      },
    })
  );

  return {
    articles:
      data && data.data
        ? [
            data.data.featured_big_tile_article,
            ...data.data.featured_small_tile_articles,
          ]
        : [],
  };
}
